import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { GetProcessStatusRequestModel, GetProcessStatusResponseModel } from "@/features/accounts/ocr/services/get-process-status-model";

export class GetProcessStatusApi {
  /**
   * OCR読み取り状況取得API
   */
  public GetProcessStatus = async (
    param: GetProcessStatusRequestModel
  ): Promise<GetProcessStatusResponseModel> => {
    const path = `/api/ocraccounts/status`;

    const res = await ApiClient.instance.get<GetProcessStatusResponseModel>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
